import axios from "axios";
import server_config from '../ServerConfiguration';

const fevir_node_server_address = server_config["fevir_node_server_address"];

const getResourceDictionaryFromFoiList = async (apiToken = null, connectionId = null, foiList = null) => {
    if (!foiList) {
        //console.log("no foiList");
        return null;
    }
    if (foiList.length === 0) {
        //console.log("empty foiList");
        return null;
    }
    //console.log("CALLING SERVER with getresourcedictionaryfromfoilistwithoutrecursion")
    return await axios({
        method: 'POST',
        url: fevir_node_server_address,
        timeout: 120000,
        data: {
            'functionid': 'getresourcedictionaryfromfoilistwithoutrecursion',
            'apiToken': apiToken,
            'connectionId': connectionId, //For SSE alerts in case a resource changes, the user will later get an alert
            'foiList': foiList
        },
    }).then((resp) => {
        if (resp?.data) {
            //resp.data is { "success": true, "resourceDictionary": resourceDictionary }
            // resourceDictionary is object with key=FOI and value=reourceJson
            //console.log("Successful RESPONSE from getresourcedictionaryfromfoilistwithoutrecursion call");
            return resp.data;
        }
        console.log("NO RESPONSE from getresourcedictionaryfromfoilistwithoutrecursion call");
    }).catch((error) => { console.log(error); });
}

export default getResourceDictionaryFromFoiList;